module.exports = __webpack_public_path__ + "img/vehicle-test-07.f91f3b15.png";